import React from 'react';
import { SchwebenderToast, useToastPill } from '../../../../components/immobilien/ui';
import { useMobilModus } from '../../../../lib/immobilien/mobil';
import { SignaturVorlagen } from './SignaturVorlagen';
import { BriefVorlagen } from './BriefVorlagen';
import { BriefkoepfeAbsender } from './BriefkoepfeAbsender';

/** Vorlagen (Handoff Dokumente §6.5): Signatur-Vorlagen und Brief-Vorlagen mit Platzhaltern. */
export function VorlagenTab({ userId, onEditor }: { userId: string | null; onEditor: (id: string) => void }) {
  const { mobil } = useMobilModus();
  const [toast, zeigeToast] = useToastPill(3200);
  return (
    <div className="flex flex-col min-w-0" style={{ gap: 28 }}>
      <SignaturVorlagen userId={userId} onEditor={onEditor} onMeldung={zeigeToast} mobil={mobil} />
      <BriefVorlagen onMeldung={zeigeToast} mobil={mobil} />
      <BriefkoepfeAbsender onMeldung={zeigeToast} mobil={mobil} />
      <SchwebenderToast toast={toast} mobil={mobil} />
    </div>
  );
}
